import request from '@/common/js/request'

/**
 * 投票
 */
export const voteVoteIdOptionsChoicesPut = (option = {}) => {
    return request({
        url: '/apis/vote/{voteId}/options/choices',
        method: 'put',
        ...option
    })
}
